globalThis.WorldListItem = class WorldListItem {
  constructor(world) {
    const { name, host } = world;
    const size = world.getSize();
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.classList.add("world-list-item");
    this.div.innerHTML = `
      <div class="thumbnail"></div>
      <h3>${name}</h3>
      <div class="footer">
        <small>${size}</small>
        <div class="control"></div>
      </div>
    `;
    this.div
      .querySelector(".thumbnail")
      .append(new WorldThumbnail(world).canvas);
    this.control = this.div.querySelector(".control");
    if (!host) {
      this.delete = document.createElement("button");
      this.delete.className = "delete";
      this.delete.innerText = "Delete";
      this.control.append(this.delete);
      this.delete.addEventListener(
        "click",
        () =>
          new Dialogue({
            center_x: true,
            body: `Are you sure you want to delete save "${name}"?`,
            action: () => globalThis.STORE.deleteWorld(name),
          }),
        this.abort,
      );
    }
    this.play = document.createElement("button");
    this.play.className = "play";
    this.play.innerText = "Play";
    this.control.append(this.play);
    this.play.addEventListener(
      "click",
      () => {
        if (host) {
          if (host.startsWith("localhost"))
            globalThis.ROUTER.goto(`/ws/${host}`);
          else globalThis.ROUTER.goto(`/wss/${host}`);
        } else globalThis.ROUTER.goto(`/local/${name}`);
      },
      this.abort,
    );
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }
};
